export interface Partner {
  id: number;
  name: string;
  partnerType: string;
  description?: string;
  website?: string;
  contactEmail?: string;
  contactPhone?: string;
  address?: string;
  logo?: string;
  isActive: boolean;
  createdAt: string;
  /** Indicates if this is a user's custom partner (local partner) */
  isCustomPartner?: boolean;
}

export interface CreatePartnerRequest {
  name: string;
  partnerType: string;
  description?: string;
  website?: string;
  contactEmail?: string;
  contactPhone?: string;
  address?: string;
  logo?: string;
  isActive?: boolean;
}

export interface UpdatePartnerRequest {
  name?: string;
  partnerType?: string;
  description?: string;
  website?: string;
  contactEmail?: string;
  contactPhone?: string;
  address?: string;
  logo?: string;
  isActive?: boolean;
}

export enum PartnerType {
  Sponsor = 'sponsor',
  TravelAgency = 'travel-agency',
  Hotel = 'hotel',
  Restaurant = 'restaurant',
  Transport = 'transport',
  Other = 'other'
}

export const PartnerTypeLabels: Record<PartnerType, string> = {
  [PartnerType.Sponsor]: 'Sponsor',
  [PartnerType.TravelAgency]: 'Reisebüro',
  [PartnerType.Hotel]: 'Hotel',
  [PartnerType.Restaurant]: 'Restaurant',
  [PartnerType.Transport]: 'Transport',
  [PartnerType.Other]: 'Sonstiges'
};

export const PartnerTypeColors: Record<PartnerType, string> = {
  [PartnerType.Sponsor]: '#28a745',
  [PartnerType.TravelAgency]: '#007bff',
  [PartnerType.Hotel]: '#6f42c1',
  [PartnerType.Restaurant]: '#fd7e14',
  [PartnerType.Transport]: '#20c997',
  [PartnerType.Other]: '#6c757d'
};
